import http from "@/settings/apiSettings"
class UserCompanyDataService {
    getAll(): Promise<any> {
        return http.clientAuth.get("/AUTH_Users/GetUsers");
    }

    updateByCompanyId(id: string, payload: { Email: string }) {
      return http.clientAuth.patch(`/AUTH_Users/UpdateUserCompany/${id}`, payload);
    }

    save(data: any): Promise<any> {
      return http.clientAuth.post("/auth/AddUserToCompany", data);
    }

    generateRandomPassword(companyId){
      return http.clientAuth.post(`/AUTH_Users/${companyId}/reset-password`);
    }

}

export default new UserCompanyDataService();